"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Colors = _interopRequireDefault(require("../Colors/Colors"));

require("./Label.css");

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _Paragraph = _interopRequireDefault(require("../../Typography/Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Basic Label
 */
function Label(_ref) {
  var color = _ref.color,
      children = _ref.children,
      isNumeric = _ref.isNumeric,
      isRemovable = _ref.isRemovable,
      isAlert = _ref.isAlert,
      onClick = _ref.onClick,
      className = _ref.className;
  var styles = {
    backgroundColor: Label.colors[color][0],
    color: Label.colors[color][1]
  };
  var styleNumeric = {
    backgroundColor: _Colors.default.lavendel,
    color: '#fff'
  };

  if (isAlert) {
    styleNumeric.backgroundColor = _Colors.default.hapumarjapuu;
  }

  var classNames = (isNumeric ? 'numeric-label ' : 'basic-label ') + (className || '');

  if (isNumeric) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames,
      style: styleNumeric
    }, /*#__PURE__*/_react.default.createElement("span", null, children));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classNames,
      style: styles,
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      fontSize: "12",
      color: styles.color
    }, children), !!isRemovable && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "times",
      color: styles.color,
      size: "16px"
    }));
  }
}

Label.propTypes = {
  /** Label */
  children: _propTypes.default.node.isRequired,

  /** The color of the label */
  color: _propTypes.default.oneOf(['blue', 'grey', 'red', 'green', 'orange', 'yellow']),

  /** The type of the label */
  isNumeric: _propTypes.default.bool,

  /** Whether can be closed (removed) or not */
  isRemovable: _propTypes.default.bool,

  /** Whether Number Label is with notification or not */
  isAlert: _propTypes.default.bool,

  /** Gets called when the user clicks on the button */
  onClick: _propTypes.default.func
};
Label.defaultProps = {
  color: 'blue',
  isNumeric: false,
  isRemovable: false,
  isAlert: false,
  onClick: function onClick(event) {}
};
Label.colors = {
  blue: [_Colors.default.withOpacity(_Colors.default.sinineVaal, 0.1), _Colors.default.sinineVaal],
  grey: [_Colors.default.withOpacity(_Colors.default.vagaVesi, 0.2), _Colors.default.vagaVesi],
  red: [_Colors.default.withOpacity(_Colors.default.hapumarjapuu, 0.1), _Colors.default.hapumarjapuu],
  green: [_Colors.default.withOpacity(_Colors.default.maismaa, 0.1), _Colors.default.maismaa],
  orange: [_Colors.default.withOpacity(_Colors.default.loojang, 0.1), _Colors.default.loojang],
  yellow: [_Colors.default.withOpacity(_Colors.default.paikesekiir, 0.2), _Colors.default.loojang]
};
var _default = Label;
exports.default = _default;